import { render, staticRenderFns } from "./Chat.vue?vue&type=template&id=680566a2&scoped=true"
import script from "./Chat.vue?vue&type=script&setup=true&lang=ts"
export * from "./Chat.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Chat.vue?vue&type=style&index=0&id=680566a2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680566a2",
  null
  
)

export default component.exports